<template>
  <div v-if="institutionalStore.institutionalDetail">
  <div>
    <c-q-separator class="q-pb-lg" :withBackButton="true" />

    <PageCaption
      pageCaptionTitle="Editar Cadastro Institucional"
      pageCaptionDescription=""
    />

  
<InstitutionalIdentificationSectionView
  :institutionalData="institutionalStore.institutionalDetail"
/>


    <c-q-separator class="q-pt-lg q-pb-lg" />

    <InstitutionalIdentificationSectionEdit />

    <InstitutionalFormatSectionEdit />

    <c-q-separator class="q-my-md" />
    
<InstitutionalAccordion
        v-if="institutionalEditData"
        ref="accordionRef"
        :accordionsData="institutionalEditData.accordions"
        mode="edit"
      />


     <InstitutionalActionButtonsSection
        :propShowBtnReviewFocusedCampaign="true"
        :accordionRef="accordionRef"
      />
    
    <c-q-separator class="q-my-md" />

  </div>
</div>
</template>

<script setup lang="ts">
import PageCaption	                      from '@/components/PageCaption.vue';
import InstitutionalIdentificationSectionView from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionView.vue';
import InstitutionalIdentificationSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionEdit.vue';
import InstitutionalFormatSectionEdit from '@/components/telasInstitucionais/institutionalFormats/InstitutionalFormatSectionEdit.vue';
import InstitutionalActionButtonsSection from '@/components/telasInstitucionais/institutionalFormats/InstitutionalActionButtonsSection.vue';
import InstitutionalAccordion from '@/components/telasInstitucionais/institutionalFormats/InstitutionalAccordion.vue'
import { useInstitutionalStore } from '@/stores/institutionalStore';
import { onMounted, computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';

const accordionRef = ref<any>(null)



const institutionalStore = useInstitutionalStore();
const router = useRouter();

const route = useRoute();

const institutionalId = computed(() => Number(route.params.id));


/*onMounted(async () => {
  const from = sessionStorage.getItem('from');

  if (!from) {
    router.push({ name: 'home' });
    return;
  }

  sessionStorage.removeItem('from');

  // ✅ AQUI ESTÁ O QUE FALTAVA
  if (institutionalId.value) {
    await institutionalStore.fetchInstitutionalById(institutionalId.value);
  }
});*/

onMounted(async () => {
  const from = sessionStorage.getItem('from');

  if (!from) {
    router.push({ name: 'home' });
    return;
  }

  sessionStorage.removeItem('from');

  // ✅ Se vem de 'review', não recarrega (preserva alterações)
  if (from === 'review') {
    return
  }

  // ✅ Se vem de outro lugar, recarrega normalmente
  if (!institutionalStore.institutionalDetail && institutionalId.value) {
    await institutionalStore.fetchInstitutionalById(institutionalId.value);
  }
});






/*const institutionalEditData = computed(() => {
  const detail = institutionalStore.institutionalDetail;

  if (!detail) return null;

  const imagens = detail.imagens || [];

  return {
    ...detail,
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1 },
        { id: 2, tela: 'Tela 2', posicao: 2 },
        { id: 3, tela: 'Tela 3', posicao: 3 },
        { id: 4, tela: 'Tela 4', posicao: 4 }
      ],
      telasAtm: [
        { id: 8, botao: 'Botão 1', posicao: 8 },
        { id: 9, botao: 'Botão 2', posicao: 9 }
      ],
      telasAguardeGeral: [{ id: 6, tela: 'Tela Geral', posicao: 6 }],
      telasAguardeChip: [{ id: 7, tela: 'Tela Chip', posicao: 7 }],
      telasAbertura: [{ id: 5, tela: 'Tela Abertura', posicao: 5 }],

      // ✅ ESSENCIAL
      imagens: imagens
    }
  };
});*/

const institutionalEditData = computed(() => {
  const detail = institutionalStore.institutionalDetail;

  if (!detail) return null;

  const imagens = detail.imagens || [];

   const mapTempo = (posicao: number) => {
    const img = imagens.find((i: any) => i.posicaoImagem === posicao)
    return img?.duracaoImagem || 10
  }

  const temImagem = (posicoes: number[]) => 
        imagens.some(img => posicoes.includes(img.posicaoImagem))

  return {
    ...detail, // ✅ já tem id aqui
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1, tempo: mapTempo(1) },
        { id: 2, tela: 'Tela 2', posicao: 2, tempo: mapTempo(2) },
        { id: 3, tela: 'Tela 3', posicao: 3, tempo: mapTempo(3) },
        { id: 4, tela: 'Tela 4', posicao: 4, tempo: mapTempo(4) }
      ],
      telasAtm: [
        /* { id: 8, botao: 'Botão 1', posicao: 8 },
        { id: 9, botao: 'Botão 2', posicao: 9 },
        { id: 10, botao: 'Botão 3', posicao: 10 },
        { id: 11, botao: 'Botão 4', posicao: 11 }*/
         { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
         { id: 9, botao: 'Recarga celular', posicao: 9 },
         { id: 10, botao: 'Mais serviços', posicao: 10 },
         { id: 11, botao: 'Depositar dinheiro', posicao: 11 },
      ],
      telasAguardeGeral: [{ id: 6, tela: 'Tela Geral', posicao: 6 }],
      telasAguardeChip: [{ id: 7, tela: 'Tela Chip', posicao: 7 }],
      telasAbertura: [{ id: 5, tela: 'Tela Abertura', posicao: 5 }],
      imagens: imagens,
      corTexto: detail.corTexto ?? null,
      exibeTelaAbertura: detail.exibeTelaAbertura ?? true,

      alterarTelaInicial: temImagem([1,2,3,4,8,9,10,11]),
      alterarTelaAguarde: temImagem([6,7]),

      alterarTelaAbertura: (
        temImagem([5]) || detail.exibeTelaAbertura
      )
    }
  };
});





</script>

<style scoped>

</style>